<main class="public-page">
  <menu-portale></menu-portale>

  <section-title title="Dicono di noi"></section-title>

  <section class="portale-section portale-section--tint">
    <div class="testimonial-card">
      <mat-icon>format_quote</mat-icon>
      <h2>Il Sole 24 Ore</h2>
      <p>Leggi l'articolo che racconta il progetto.</p>
      <a href="assets/portal/images/dicono1.jpg" target="_blank" rel="noopener">Apri l'articolo</a>
    </div>
  </section>

  <app-scarica-app-section></app-scarica-app-section>

  <app-portale-layout-footer></app-portale-layout-footer>
</main>
